import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useEffect, useState } from "react";
// import { categoriesData } from "./data";
import {
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} from "slices/beautyApp/categorySlice";
import { Button } from "@mui/material";
import AddForm from "./addForm";

function ProfessionalCharges() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [add] = useAddCategoryMutation();
  const [update] = useUpdateCategoryMutation();
  const [del] = useDeleteCategoryMutation();

  const { data, isLoading, refetch } = useGetCategoriesQuery({
    page,
    limit,
    search,
  });

  const col = [
    { display: "Type", key: "type", type: "display" },
    {
      display: "Price",
      key: "price",
      type: "display",
    },
    {
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          <Button onClick={() => onEdit(row)}>Edit</Button>
          <Button onClick={() => handleDelete(row._id)}>Delete</Button>
        </>
      ),
    },
  ];

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (p, l) => {
    setPage(p);
    setLimit(l);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const handleSubmit = async (data) => {
    try {
      if (editing) {
        await update(data).unwrap();
        refetch();
      } else {
        await add(data).unwrap();
        refetch();
      }
      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddForm
        open={open}
        onClose={() => setOpen(false)}
        initialData={editing}
        onSubmit={handleSubmit}
      />
      <Button onClick={handleAdd} style={{ background: "#fff" }}>
        Add Professional Charges
      </Button>

      <Tables
        title={"Professionals"}
        handleSearch={handleSearchChange}
        totalPages={0}
        data={[]}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default ProfessionalCharges;
